import PropTypes from 'prop-types'
import React from 'react'
import Icon from '../../../../../atoms/Icon'

function ToolbarIconButton ({ title, onClick, icon }) {
  return (
    <button
      type='button'
      title={title}
      aria-label={title}
      onClick={onClick}
      className='flex items-center justify-center'
      style={{
        color: 'var(--color-neutral-800)',
        cursor: 'pointer',
        padding: 'var(--dim-2) var(--dim-3)',
        borderLeft: '1px solid var(--color-neutral-300)'
      }}
    >
      <Icon name={icon} customSize={14} />
    </button>
  )
}

ToolbarIconButton.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  icon: PropTypes.string.isRequired
}

ToolbarIconButton.defaultProps = {
  onClick: undefined
}

function CodeEditorToolbar ({
  diagnostics,
  onFind,
  onReplace,
  onFormat,
  onUndo,
  onRedo
}) {
  const diagnosticsCount = diagnostics.length
  const firstMessage = diagnostics[0]?.text || ''
  const diagnosticsLabel = diagnosticsCount === 1
    ? `1 JSX issue: ${firstMessage}`
    : `${diagnosticsCount} JSX issues`

  return (
    <div
      className='flex items-center justify-between'
      style={{
        borderBottom: '1px solid var(--color-neutral-300)',
        background: 'var(--color-neutral-100)',
        zIndex: 2
      }}
    >
      <div className='flex-1 px-2'>
        {diagnosticsCount > 0 && (
          <div
            className='text-xs font-bold truncate'
            style={{ color: 'var(--color-danger-600)' }}
            title={diagnosticsLabel}
          >
            {diagnosticsLabel}
          </div>
        )}
      </div>
      <div className='flex items-center'>
        <ToolbarIconButton title='Find (Cmd/Ctrl+F)' onClick={onFind} icon='search' />
        <ToolbarIconButton title='Replace (Cmd+Alt+F / Ctrl+H)' onClick={onReplace} icon='sync' />
        <ToolbarIconButton title='Format JSX' onClick={onFormat} icon='verticalSplit' />
        <ToolbarIconButton title='Undo (Cmd/Ctrl+Z)' onClick={onUndo} icon='history' />
        <ToolbarIconButton title='Redo (Cmd+Shift+Z / Ctrl+Y)' onClick={onRedo} icon='update' />
      </div>
    </div>
  )
}

CodeEditorToolbar.propTypes = {
  diagnostics: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string
  })),
  onFind: PropTypes.func,
  onReplace: PropTypes.func,
  onFormat: PropTypes.func,
  onUndo: PropTypes.func,
  onRedo: PropTypes.func
}

CodeEditorToolbar.defaultProps = {
  diagnostics: [],
  onFind: undefined,
  onReplace: undefined,
  onFormat: undefined,
  onUndo: undefined,
  onRedo: undefined
}

export default CodeEditorToolbar
